"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var icon_1 = __importDefault(require("../icon"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var Tag = function (props) {
    var icon;
    if (props.onRemove) {
        var handleRemove = function (evt) {
            evt.stopPropagation();
            props.onRemove(evt);
        };
        icon = (React.createElement("a", __assign({ onClick: handleRemove }, automation_attribute_1.default('tag.remove')),
            React.createElement(icon_1.default, { name: "close", size: 9 })));
    }
    return (React.createElement(Tag.Element, __assign({}, automation_attribute_1.default('tag'), props),
        props.children,
        icon));
};
Tag.Element = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", ";\n  color: ", ";\n  line-height: 1;\n  padding: ", " ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  cursor: ", ";\n\n  ", " {\n    cursor: pointer;\n    stroke: ", ";\n    margin-left: ", ";\n  }\n"], ["\n  display: inline-block;\n  font-size: ", ";\n  color: ", ";\n  line-height: 1;\n  padding: ", " ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  cursor: ", ";\n\n  ", " {\n    cursor: pointer;\n    stroke: ", ";\n    margin-left: ", ";\n  }\n"])), tokens_1.fonts.size.small, tokens_1.colors.tag.text, tokens_1.spacing.xxsmall, tokens_1.spacing.xsmall, tokens_1.colors.tag.background, tokens_1.colors.tag.border, tokens_1.misc.radius, function (props) { return (props.onClick ? 'pointer' : 'inherit'); }, icon_1.default.Element, tokens_1.colors.tag.text, tokens_1.spacing.xsmall);
var TagGroup = function (props) { return (React.createElement(Tag.Group.Element, __assign({}, automation_attribute_1.default('tag.group'), props), props.children)); };
TagGroup.Element = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], ["\n  ", " {\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"])), Tag.Element, tokens_1.spacing.xsmall);
Tag.Group = TagGroup;
Tag.defaultProps = {};
var StyledTag = Tag.Element;
exports.StyledTag = StyledTag;
exports.default = Tag;
var templateObject_1, templateObject_2;
//# sourceMappingURL=tag.js.map